const config = window.appConfig || {
  auth0Domain: 'login-ci.dfinsolutions.com',
  auth0Audience: 'https://integration.dfin-dev.auth0app.com/api/v2/',
  auth0ClientID: 'TNV3UQhQUJz8U8Ae5JPd7h8xO9E2rNHd',
};

export default config;
